import Referrals from '@/components/referrals';

export default Referrals;
